// TODO: Once the shared folder is available for use, move requireEnvVariable and getEnvVariable there. https://app.clubhouse.io/alpha-hq/story/958/support-shared-typescript-packages-in-ocean-monorepo
function requireEnvVariable (name: string): string {
  const value = process.env[name]
  if (!value) {
    throw new Error(`Required environment variable ${name} was not provided.`)
  }

  return value
}

function getEnvVariable (name: string, options: { requiredInProduction?: boolean, default?: string }): string | undefined {
  if (options.requiredInProduction && NODE_ENV === 'production') {
    return requireEnvVariable(name)
  }

  let value = process.env[name]
  if (!value) {
    if (options.default) {
      value = options.default
      console.log(`Environment variable ${name} was not provided. Using default.`)
    } else {
      console.log(`Environment variable ${name} was not provided. Ignoring.`)
    }
  }

  return value
}

export const NODE_ENV = requireEnvVariable('NODE_ENV')
export const VUE_APP_API = getEnvVariable('VUE_APP_API', { requiredInProduction: false })
// force change to update legacy api
export const VUE_APP_LEGACY_API = getEnvVariable('VUE_APP_LEGACY_API', { requiredInProduction: true, default: 'https://mgt-staging-stage07.herokuapp.com' })
export const VUE_APP_LOGROCKET_PROJECT = getEnvVariable('VUE_APP_LOGROCKET_PROJECT', { requiredInProduction: false })
export const VUE_APP_SENTRY_DSN = getEnvVariable('VUE_APP_SENTRY_DSN', { requiredInProduction: false })
export const VUE_APP_VERSION = getEnvVariable('VUE_APP_VERSION', { requiredInProduction: false })
export const VUE_APP_INTERCOM_APP_ID = getEnvVariable('VUE_APP_INTERCOM_APP_ID', { requiredInProduction: false })
export const VUE_APP_SLACK_CLIENT_ID = getEnvVariable('VUE_APP_SLACK_CLIENT_ID', { requiredInProduction: false, default: '2535901906.242348751217' })
export const VUE_APP_PENDO_LICENSE_KEY = getEnvVariable('VUE_APP_PENDO_LICENSE_KEY', { requiredInProduction: true })
export const ASSETS_URL = getEnvVariable('VUE_APP_ASSETS_URL', { default: 'https://uploads.feedbackloop.com/' }) as string

// TODO Remove this once organization-level Audiences land
// https://app.clubhouse.io/alpha-hq/story/7442/ui-work
export const enableOrganizationWorkspaces = true
